var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasNext
    ? _c("div", { staticClass: "row m-t-sm" }, [
        _c("div", { staticClass: "flexbox justify-center" }, [
          _c(
            "a",
            {
              staticClass: "text--underline",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.loadMore($event)
                }
              }
            },
            [_vm._v("\n      もっと見る\n    ")]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-053111b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053111b5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/components/DeliveryRequestsPagination.vue
// module id = null
// module chunks = 